import type { NextPage } from "next";
import { useTranslation } from "next-i18next/pages";
import SubpageShell from "components/common/SubpageShell";
import {
  CMS_REVALIDATE_SECONDS,
  serverSideCmsTranslations
} from "lib/cms/translations";
import styles from "../../styles/impressum/Impressum.module.css";

interface ImpressumSection {
  title: string;
  lines: string[];
}

export async function getStaticProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideCmsTranslations(locale, ["common", "impressum"]))
    },
    revalidate: CMS_REVALIDATE_SECONDS
  };
}

const ImpressumPage: NextPage = () => {
  const { t } = useTranslation("impressum");
  const sections: ImpressumSection[] = t("sections", { returnObjects: true }) as ImpressumSection[];

  return (
    <SubpageShell
      title={t("global.websiteTitle")}
      description={t("global.websiteDescription")}
      path="/impressum"
      heading={t("heading")}
      subtitle=""
    >
      <div className={styles.container}>
        {sections.map((section: ImpressumSection) => (
          <section key={section.title} className={styles.section}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            {section.lines.map((line: string) => (
              <p key={line} className={styles.line}>
                {line}
              </p>
            ))}
          </section>
        ))}
      </div>
    </SubpageShell>
  );
};

export default ImpressumPage;
